<template>
  <layout-component>
    <div class="banner banner-book noise">
      <div class="container">
          <h1 class="left-bullet" v-html="$t('w.book.title-banner')"></h1>
      </div>
    </div>
    <div class="container-full container-white container-booking">
      <div class="container">
        <div class="row filter-book" v-if="$store.settings.bookings_disabled">
          <div class="col-12">
            <p class="h4-style bottom-cut mt-2">{{'w.book.bookings-closed'|t}}</p>
          </div>
        </div>
        <div v-else class="row filter-book">
          <!-- <div class="col-12 col-lg-3">
            <p class="title">{{'w.book.filter-title-01'|t}}</p>
            <b-form-group>
              <b-form-radio-group id="what" v-model="what" name="what">
                <b-form-radio value="rehearse" @click.native.prevent="whatClick('rehearse')">{{'w.book.rehearse'|t}}</b-form-radio>
                <b-form-radio value="record" @click.native.prevent="whatClick('record')">{{'w.book.record'|t}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div> -->

          <div class="col-12 col-lg-3">
            <p class="title">{{'w.book.filter-title-02'|t}}</p>
            <datepicker v-model="when" @input="filterRooms()" monday-first :disabled-dates="disabledDates" :placeholder="placeholder" :format="format" :open-date="datepickerOpenDate"></datepicker>
          </div>

          <div class="col-6 col-lg-3">
            <p class="title">{{'w.book.filter-title-03'|t}}</p>

            <div class="select-wrapper">
              <b-form-select v-model="from" ref="fromSelect" @input="filterRooms()">
                <option v-for="(hour, index) in fromSlots" v-if="isValidFromHour(hour)" :value="hour.value" :key="index">{{hour.text}}</option>
              </b-form-select>
            </div>

          </div>

          <div class="col-6 col-lg-3">
            <p class="title">{{'w.book.filter-title-04'|t}}</p>
            <div class="select-wrapper">
              <b-form-select v-model="to" ref="toSelect" @input="filterRooms()">
                <option v-for="(hour, index) in toSlots" v-if="isValidHour(hour)" :value="hour.value" :key="index">{{hour.text}}</option>
              </b-form-select>
            </div>
          </div>

          <div class="col-12 col-lg-3">
            <p class="title">{{'w.book.filter-title-05'|t}}</p>
            <div class="select-wrapper">
              <b-form-select v-model="howmany" :options="howmanySelect" @input="filterRooms()" />
            </div>
          </div>
          <div class="col-12 mt-1" v-if="$auth.check(2)">
            <p class="title">{{'w.book.admin-comment'|t}}</p>
            <b-form-input v-model="adminComment" placeholder="e.g. Customer Name"></b-form-input>
          </div>
        </div>

        
      </div>

      <div class="container pt-2 pb-3 pt-lg-4 pb-lg-5" v-if="! periodOpen">
        <div class="row">
          <div class="col-12">
            <p class="h4-style bottom-cut mt-2">{{'w.book.period-closed'|t}}</p>
          </div>
        </div>
      </div>


      <div class="container pt-2 pb-3 pt-lg-4 pb-lg-5" v-if="periodOpen">
        <div class="row">
            <div class="col-md-12">
              <b-list-group class="rooms-list">
                <div v-for="(room,index) in $store.rooms.content" :key="'room-' + index">

                    <b-list-group-item class="room" :class="{ 'room-blocked': room.blockedReason }" v-if="!room.hide && $store.rooms.content[room.id-1]">
                      <div class="room-wrapper">
                        <div class="room-name-wrapper">
                           <img :src="$store.rooms.content[room.id-1].images[0]" :alt="`room ${room.id}`" loading="lazy">
                           <div class="bg"></div>
                           <span class="name">{{room.name}}</span>
                        </div>
                        <div class="room-size-wrapper">
                          <p>
                            <span class="area">{{room.area}} m²</span>
                            <span class="capacity">max. {{room.capacity}} {{'w.book.pers'|t}}</span>
                            <span class="floor">{{ $t('w.book.floor-' + room.floor) }}</span>
                          </p>
                          <p class="mb-0">{{room.gear | truncate(95) }}</p>
                        </div>
                        <div class="room-price-wrapper">
                          <template v-if="from && to">
                            <template v-if="from==10 && to==22">
                              <div class="hourly"><span>{{room.daily_rate}}€</span></div>
                              <div class="daily"><span>{{formatPrice(room.daily_rate/12)}}€</span>/h</div>
                            </template>
                            <template v-else>
                              <div class="hourly"><span>{{room.hourly_rate*(to-from)}}€</span></div>
                              <div class="daily"><span>{{formatPrice(room.hourly_rate)}}€</span>/h</div>
                            </template>
                          </template>
                          <template v-else>
                            <div class="hourly"><span>{{room.hourly_rate}}€</span>/h</div>
                            <div class="daily"><span>{{room.daily_rate}}€</span>/{{'w.book.day'|t}}</div>
                          </template>
                        </div>
                        <div class="room-buttons-wrapper">
                          <p v-if="room.blockedReason" class="room-blocked-reason">{{'w.book.room-unavailable'|t}}: {{room.blockedReason}}</p>
                          <b-button v-else-if="!$store.settings.bookings_disabled" v-b-tooltip="tooltipOptions" variant="outline-secondary" @click="book(room)" :class="{'cant-book':! allowBooking()}"><span>{{'w.book.btn-book'|t}}</span></b-button>
                          <b-button variant="outline-secondary" v-b-modal="'r'+room.id" class="btn-link">{{'w.book.btn-view-more'|t}}</b-button>
                        </div>
                      </div>
                    </b-list-group-item>

                    <!-- Modal -->
                    <b-modal :id="'r'+room.id" ref="roomModal" size="xl" dialog-class="room-detail-dialog" scrollable centered hide-footer hide-header @shown="modalopen">
                      <div class="row">
                        <div class="col-lg-7">
                          <swiper :options="swiperOption" :ref="'swiper'+room.id">
                            <swiper-slide v-for="image in room.images" :key="image" :style="'background-image:url(\''+image+'\')'"></swiper-slide>
                            <div class="swiper-pagination" slot="pagination"></div>
                            <div class="swiper-button-prev" slot="button-prev"></div>
                            <div class="swiper-button-next" slot="button-next"></div>
                          </swiper>
                        </div>
                        <div class="col-lg-5 content-right">
                          <button type="button" :aria-label="$t('w.common.close')" class="close" @click="hideModal()"><b-img src="/storage/img/icon/icon-cross-close-modal.svg" class="cross-close-modal" width="16" height="16" /></button>



                          <div class="infos">
                            <div class="header align-items-center justify-content-between" :class="{ 'header-fr': $i18n.locale == 'fr' }">
                              <div class="h1-style">{{ room.name }}</div>
                              <div class="header-infos">
                                <p v-if="room.daylight == '1'">{{'w.book.natural-light'|t}}</p>
                                <p v-if="room.daylight == '0'">{{'w.book.no-natural-light'|t}}</p>
                                <p>{{ $t('w.book.floor-' + room.floor) }}</p>
                              </div>

                            </div>

                            <div class="row description infos-section">
                              <div class="col-md-12">
                                <h3 class="left-bullet">{{'w.book.description'|t}}</h3>
                              </div>
                              <div class="col-md-6 info" v-if="room.pa">
                                <p class="title">{{'w.book.pa'|t}}</p>
                                <p v-html="room.pa"></p>
                              </div>

                              <div class="col-md-6 info" v-if="room.layout">
                                <p class="title">{{'w.book.uponrequest'|t}}</p>
                                <p v-html="room.layout"></p>
                              </div>

                              <div class="col-md-6 info" v-if="room.mixer">
                                <p class="title">{{'w.book.mixer'|t}}</p>
                                <p v-html="room.mixer"></p>
                              </div>

                              <div class="col-md-6 info" v-if="room.guitar_amp">
                                <p class="title">{{'w.book.guitare-amplifier'|t}}</p>
                                <p v-html="room.guitar_amp"></p>
                              </div>

                              <div class="col-md-6 info" v-if="room.bass_amp">
                                <p class="title">{{'w.book.bass-amplifier'|t}}</p>
                                <p v-html="room.bass_amp"></p>
                              </div>

                              <div class="col-md-6 info" v-if="room.drums">
                                <p class="title">{{'w.book.drums'|t}}</p>
                                <p v-html="room.drums"></p>
                              </div>

                              <div class="col-md-6 info" v-if="room.dj">
                                <p class="title">{{'w.book.dj'|t}}</p>
                                <p v-html="room.dj"></p>
                              </div>

                              <div class="col-md-6 info" v-if="room.music_prod">
                                <p class="title">{{'w.book.music-prod'|t}}</p>
                                <p v-html="room.music_prod"></p>
                              </div>
                            </div>

                            <div class="row room-size infos-section">
                              <div class="col-md-12">
                                <h3 class="left-bullet">{{'w.book.room-size'|t}}</h3>
                              </div>

                              <div class="col-md-12 info">
                                <img class="img-fluid"  v-if="room.image_room_size" :src="room.image_room_size" loading="lazy" :alt="`Plan ${room.name}`" />
                              </div>

                              <div class="col-6 col-md-4 info" v-if="room.length">
                                <p>{{'w.book.length'|t}}</p>
                                <p v-html="room.length + 'cm'" class="title"></p>
                              </div>

                              <div class="col-6 col-md-4 info" v-if="room.width">
                                <p>{{'w.book.width'|t}}</p>
                                <p v-html="room.width +  'cm'" class="title"></p>
                              </div>

                              <div class="col-6 col-md-4 info" v-if="room.height">
                                <p>{{'w.book.height'|t}}</p>
                                <p v-html="room.height +  'cm'" class="title"></p>
                              </div>

                              <!-- <div class="col-md-12 info">
                                <a :href="'/storage/pdf/room-'+ room.name +'-plan-sonotron.pdf'" target="_blank" class="btn-link">{{'w.book.download-plan'|t}}</a>


                              </div> -->

                            </div>

                            <div class="row room-need-more infos-section">
                              <div class="col-md-12">
                                <h3 class="left-bullet">{{'w.book.need-more-title'|t}}</h3>
                              </div>
                              <div class="col-md-12">
                                <p v-html="$t('w.book.need-more-text')"></p>
                              </div>
                            </div>


                            <div class="row room-rules infos-section">
                              <div class="col-md-12">
                                <h3 class="left-bullet">{{'w.book.rules-title'|t}}</h3>
                              </div>
                              <div class="col-md-12">
                                <p v-html="$t('w.book.rules-text')"></p>
                              </div>
                            </div>
                          </div>

                          <div class="bottom-infos d-flex align-items-center">
                            <p v-if="room.blockedReason" class="room-blocked-reason order-lg-2">{{'w.book.room-unavailable'|t}}: {{room.blockedReason}}</p>
                            <b-button v-else v-b-tooltip="tooltipOptions" variant="outline-secondary" @click="book(room)" :class="{'cant-book': ! allowBooking()}" class="order-lg-2"><span>{{'w.book.btn-book'|t}}</span></b-button>
                            <div class="room-price-wrapper mr-lg-auto order-lg-1">
                              <div class="hourly"><span>{{room.hourly_rate}}€</span>/h</div>
                              <div class="daily"><span>{{room.daily_rate}}€</span>/{{'w.book.day'|t}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-modal>
                </div>
              </b-list-group>

              <p class="small small-bottom-text" v-html="$t('w.book.room-bottom-text')"></p>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row d-flex align-items-center pb-4 pb-md-5">
            <div class="col-md-5">
              <div class="noise">
                <b-img src="/storage/img/pic/pic-book-01.webp" alt="Guitarist singing" />
              </div>
            </div>
            <div class="col-md-4 offset-md-1 mt-15">
                <p class="h4-style bottom-cut br-title" v-html="$t('w.book.title-02')"></p>
                <div v-html="$t('w.book.text-02')"></div>
            </div>
        </div>
      </div>
    </div>

    <div class="banner-prefooter banner-prefooter-book noise">
        <div class="container">
            <p class="h2-style">
                <span v-html="$t('w.book.big-cta-01-text')"></span>
                <router-link class='btn-link btn-link-big left-bullet' to='/discover' exact v-html="$t('w.book.big-cta-01')"></router-link>
            </p>
        </div>
    </div>
	</layout-component>
</template>

<script>
import Datepicker from "vuejs-datepicker"
  export default {
    components: {
      Datepicker
    },
    data() {
      return {
        bookingClosed: false, //Set to true to disable bookings (COVID-19)
        periodOpen: true,
        placeholder: "--",
        format: "dd/MM/yyyy",
        cutoffDate: new Date('2020-07-07'),
        what:null,
        when:null,
        from:null,
        to:null,
        howmany:null,
        adminComment: null,
        canBook:false,
        isWeekendToday:null,
        datepickerOpenDate: moment('2020-06-01').isAfter() ? moment('2020-06-01').toDate() : new Date(),
        fromSlots: [
          {value: null, text: '--'},
          {value:10, text:"10:00"},
          {value:12, text:"12:00"},
          {value:14, text:"14:00"},
          {value:16, text:"16:00"},
          {value:18, text:"18:00"},
          {value:20, text:"20:00"}
        ],
        toSlots: [
          {value: null, text: '--'},
          {value:12, text:"12:00"},
          {value:14, text:"14:00"},
          {value:16, text:"16:00"},
          {value:18, text:"18:00"},
          {value:20, text:"20:00"},
          {value:22, text:"22:00"}
        ],
        howmanySelect: [
          {value: null, text: '--'},
          {value:1, text:"1 max."},
          {value:2, text:"2 max."},
          {value:3, text:"3 max."},
          {value:4, text:"4 max."},
          {value:6, text:"6 max."},
          {value:10, text:"10 max."}
        ],
        swiperOption: {
          slidesPerView: 1,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        disabledDates: {
          dates: [
            new Date(2020, 5, 28),
            new Date(2020, 6, 5 )
          ],
          to: moment("2020-06-02").isAfter() ? moment("2020-06-01").toDate() : moment().subtract(1, 'days').toDate(),
          days: [1], // disable Mondays (0=Sunday, 1=Monday, 2=Tuesday, etc.)
          //disable limit date if admin
          from: this.$auth.check(2) ? null : moment().add(2, 'months').toDate()
        }
      }
    },
    methods: {
      book(room) {
        if(room.blockedReason) return; // blocked rooms are not bookable
        if(this.$auth.check()) {
          if(this.canBook && this.periodOpen) {
            Vue.axios.post('/cart', {
              room_id: room.id,
              date: moment(this.when).format('YYYY-MM-DD'),
              from: this.from,
              to: this.to,
              comment: this.adminComment,
            }).then(({data}) => {
              this.hideModal()
              this.filterRooms()
              this.$store.setCart(data)
              this.$store.cartDropdown.show()
            })
            // Échec : pas de fausse confirmation (le panier n'est pas modifié, le dropdown ne s'ouvre pas).
            .catch(() => {})
          }
        } else {
          this.$router.push('login')
        }
      },
      allowBooking() {
        if (this.canBook && this.periodOpen) {
          // Check if booking date/time is in the past
          if (this.when && this.from && this.to) {
            const selectedDate = moment(this.when);
            const today = moment();
            
            // If selected date is before today, don't allow booking
            if (selectedDate.isBefore(today, 'day')) {
              return false;
            }
            
            // If selected date is today, check if the time slot has finished
            if (selectedDate.isSame(today, 'day')) {
              const currentHour = moment().hour();
              // Check if the end time has passed (not the start time)
              if (this.to <= currentHour) {
                return false;
              }
            }
          }
          return true
        }

        return false;
      },
      modalopen() {
        Vue.nextTick(() => window.dispatchEvent(new Event('resize')))
        OverlayScrollbars(document.querySelectorAll(".infos"), {
          overflowBehavior : {
        		x : "visible-hidden",
        		y : "scroll"
        	}
        });
      },
      hideModal() {
        this.$refs.roomModal.forEach(modal => {
          modal.hide()
        })
      },
      whatClick(activity) {
        if(activity == this.what) {
          this.what = null
        } else {
          this.what = activity
        }
        this.filterRooms()
      },
      tooltipOptions() {
        if(this.$auth.check()) {
          if(this.canBook) {
            if(this.periodOpen) {
              // Check if booking date is in the past
              if (this.when && moment(this.when).isBefore(moment(), 'day')) {
                return this.$t('w.book.tooltip-time-passed');
              }
              
              // Check if booking time slot has finished (for same day bookings)
              if (this.when && this.from && this.to && moment(this.when).isSame(moment(), 'day')) {
                const currentHour = moment().hour();
                // Check if the end time has passed (not the start time)
                if (this.to <= currentHour) {
                  return this.$t('w.book.tooltip-time-passed');
                }
              }
              return '';
            } else {
              return this.$t('w.book.tooltip-change-when')
            }
          } 
          else {
            return this.$t('w.book.tooltip-choose-when')
          }
        } else {
          return this.$t('w.book.tooltip-login')
        }
      },
      formatPrice(price) {
        if (typeof price === 'undefined') {
          return 0;
        }

        return price.toLocaleString();
      },
      filterRooms() {
        // Calculate end time
        if (this.from === 20) {
          this.to = 22;
        }
        // Set isWeekend
        if (this.when) {
          this.isWeekendToday = moment().isSame(this.when, 'day') && (moment(this.when).day() === 0 || moment(this.when).day() === 6);
        }
        if (this.when && this.from && this.to) {
          if (this.to <= this.from) {
            this.to = this.from + 2;
          }
          Vue.axios.post('/room/filter', {
            when: moment(this.when).format('YYYY-MM-DD'),
            from: this.from,
            to: this.to
          }).then(({ data }) => {
            const blocked = data.blocked || {};
            this.$store.rooms.content.forEach(room => {
              room.hide = false;
              // Block reason shown on the card (room stays visible but not bookable).
              room.blockedReason = blocked[room.id] || null;
              if (this.what && this.what === "record" && room.type === "room") {
                room.hide = true;
              }
              if (room.capacity < this.howmany) {
                room.hide = true;
              }
              if (data.unavailable.indexOf(room.id) > -1) {
                room.hide = true;
              }
            });
            this.$forceUpdate();
          }).catch(() => {});
          Vue.axios.post('/room/periods', {
            when: moment(this.when).format('YYYY-MM-DD'),
            from: this.from,
            to: this.to
          }).then(({ data }) => {
            this.periodOpen = data;
          }).catch(() => {});
          this.canBook = this.$auth.check();
        } else {
          this.canBook = false;
          this.$forceUpdate();
          this.$store.rooms.content.forEach(room => {
            room.hide = false;
            room.blockedReason = null;
            if (this.what && this.what === "record" && room.type === "room") {
              room.hide = true;
            }
            if (room.capacity < this.howmany) {
              room.hide = true;
            }
          });
        }
      },
      isValidHour(hour) {
        if (this.isWeekendToday && hour.value >= 14) return true;
        if (this.when < this.cutoffDate && hour.value >= 14 && hour.value <= 20 && (!this.from || hour.value > this.from || !hour.value)) return true;
        if (this.when > this.cutoffDate && (!this.from || hour.value > this.from || !hour.value)) return true;
        return false;
      },
      isValidFromHour(hour) {
        if (this.isWeekendToday && hour.value >= 12) return true;
        if (this.when < this.cutoffDate && hour.value >= 12 && hour.value <= 18) return true;
        if (this.when > this.cutoffDate || !hour.value) return true;
        return false;
      }
    },
    mounted() {
      $('.title-anim-wrapper:in-viewport').addClass('in-viewport');
      if ( $( '.banner-prefooter .title-anim-wrapper' ).is( ':in-viewport' ) ) {
        $('.banner-prefooter').addClass('in-viewport');
      }

      $('.noise').each(function() {
        if ($(this).is( ':in-viewport' ) ) {
          $(this).addClass('in-viewport');
        } else {
          $(this).removeClass('in-viewport');
        }
      });
    }
  }
</script>

<style scoped>
  .room-blocked {
    opacity: .65;
  }
  .room-blocked-reason {
    margin: 0;
    font-weight: 600;
    font-style: italic;
    color: #888;
  }
</style>
